function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SplashTemplate = require('./splash.template');
var _require = require('../document'),
  isPdf = _require.isPdf;
var _require2 = require('../transaction'),
  looksLikeWebTransaction = _require2.looksLikeWebTransaction;
var _require3 = require('../zip'),
  isZipFile = _require3.isZipFile,
  looksLikeZip = _require3.looksLikeZip;
var Splash = /*#__PURE__*/function () {
  function Splash(app, mod, main) {
    _classCallCheck(this, Splash);
    this.app = app;
    this.mod = mod;
    this.main = main;
    this.notice = '';
    this.staged = [];
    this.drag_index = -1;
  }
  return _createClass(Splash, [{
    key: "clearStaged",
    value: function clearStaged() {
      this.staged = [];
      this.drag_index = -1;
    }
  }, {
    key: "render",
    value: function render() {
      var container = document.querySelector('.saito-container');
      if (!container) {
        return;
      }
      container.classList.add('saitosign');
      this.app.browser.replaceElementContentBySelector(SplashTemplate({
        notice: this.notice,
        files: this.staged.map(function (file) {
          return {
            name: file.name || 'document.pdf'
          };
        })
      }), '.saito-container');
      this.attachEvents();
    }
  }, {
    key: "fileInput",
    value: function fileInput() {
      if (this.input) {
        return this.input;
      }
      var input = document.createElement('input');
      input.type = 'file';
      input.accept = 'application/pdf,.pdf,.saitosign,.zip,application/zip,.saito,.json,application/json';
      input.style.display = 'none';
      input.style.visibility = 'hidden';
      this.input = input;
      return input;
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var zone = document.querySelector('.splash .dropzone');
      var input = this.fileInput();
      if (!zone || !input) {
        return;
      }
      input.onchange = function () {
        var file = input.files && input.files[0];
        input.value = '';
        if (file) {
          _this.takeFile(file);
        }
      };
      zone.onclick = function () {
        input.click();
      };
      zone.onkeydown = function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }
        event.preventDefault();
        input.click();
      };
      zone.ondragenter = function (event) {
        event.preventDefault();
        zone.classList.add('over');
      };
      zone.ondragover = function (event) {
        event.preventDefault();
        zone.classList.add('over');
      };
      zone.ondragleave = function (event) {
        if (!zone.contains(event.relatedTarget)) {
          zone.classList.remove('over');
        }
      };
      zone.ondrop = function (event) {
        event.preventDefault();
        zone.classList.remove('over');
        var file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
        if (file) {
          _this.takeFile(file);
        }
      };
      var learn = document.querySelector('.splash [data-faq]');
      if (learn) {
        learn.onclick = function () {
          return _this.main.showFaq();
        };
      }
      document.querySelectorAll('.splash [data-remove-staged]').forEach(function (button) {
        button.onclick = function (event) {
          event.preventDefault();
          event.stopPropagation();
          _this.removeStaged(Number(button.dataset.removeStaged));
        };
      });
      var prepare = document.querySelector('.splash [data-prepare]');
      if (prepare) {
        prepare.onclick = function (event) {
          event.preventDefault();
          _this.prepare();
        };
      }
      this.attachReorder();
    }
  }, {
    key: "attachReorder",
    value: function attachReorder() {
      var _this2 = this;
      var list = document.querySelector('.splash .staged-list');
      if (!list) {
        return;
      }
      list.querySelectorAll('.staged-item').forEach(function (item) {
        item.ondragstart = function (event) {
          _this2.drag_index = Number(item.dataset.stagedIndex);
          item.classList.add('dragging');
          if (event.dataTransfer) {
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('text/plain', String(_this2.drag_index));
          }
        };
        item.ondragend = function () {
          item.classList.remove('dragging');
          list.querySelectorAll('.staged-item').forEach(function (row) {
            return row.classList.remove('over');
          });
          _this2.drag_index = -1;
        };
        item.ondragover = function (event) {
          event.preventDefault();
          if (event.dataTransfer) {
            event.dataTransfer.dropEffect = 'move';
          }
          item.classList.add('over');
        };
        item.ondragleave = function () {
          item.classList.remove('over');
        };
        item.ondrop = function (event) {
          event.preventDefault();
          item.classList.remove('over');
          var target = Number(item.dataset.stagedIndex);
          var from = _this2.drag_index;
          if (!Number.isInteger(from) || from < 0 || from === target) {
            return;
          }
          _this2.moveStaged(from, target);
        };
      });
    }
  }, {
    key: "takeFile",
    value: function () {
      var _takeFile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(file) {
        var header, text, _t, _t2, _t3, _t4;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!isPdf(file)) {
                _context.n = 1;
                break;
              }
              this.stagePdf(file);
              return _context.a(2);
            case 1:
              header = new Uint8Array();
              _context.p = 2;
              _t = Uint8Array;
              _context.n = 3;
              return file.slice(0, 4).arrayBuffer();
            case 3:
              _t2 = _context.v;
              header = new _t(_t2);
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t3 = _context.v;
              header = new Uint8Array();
            case 5:
              if (!(!isZipFile(file) && !looksLikeZip(header))) {
                _context.n = 10;
                break;
              }
              text = '';
              _context.p = 6;
              _context.n = 7;
              return file.text();
            case 7:
              text = _context.v;
              _context.n = 9;
              break;
            case 8:
              _context.p = 8;
              _t4 = _context.v;
              text = '';
            case 9:
              if (!(!looksLikeWebTransaction(text) && text.slice(0, 1024).includes('%PDF'))) {
                _context.n = 10;
                break;
              }
              this.stagePdf(file);
              return _context.a(2);
            case 10:
              this.mod.importFile(file);
            case 11:
              return _context.a(2);
          }
        }, _callee, this, [[6, 8], [2, 4]]);
      }));
      function takeFile(_x) {
        return _takeFile.apply(this, arguments);
      }
      return takeFile;
    }()
  }, {
    key: "stagePdf",
    value: function stagePdf(file) {
      this.notice = '';
      this.staged.push(file);
      this.render();
    }
  }, {
    key: "removeStaged",
    value: function removeStaged(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this.staged.length) {
        return;
      }
      this.staged.splice(index, 1);
      this.render();
    }
  }, {
    key: "moveStaged",
    value: function moveStaged(from, to) {
      if (!Number.isInteger(from) || !Number.isInteger(to) || from < 0 || to < 0 || from >= this.staged.length || to >= this.staged.length) {
        return;
      }
      var _this$staged$splice = this.staged.splice(from, 1),
        _this$staged$splice2 = _slicedToArray(_this$staged$splice, 1),
        file = _this$staged$splice2[0];
      this.staged.splice(to, 0, file);
      this.render();
    }
  }, {
    key: "prepare",
    value: function () {
      var _prepare = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var files;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (this.staged.length) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              files = this.staged.slice();
              _context2.n = 2;
              return this.mod.importPdfs(files);
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function prepare() {
        return _prepare.apply(this, arguments);
      }
      return prepare;
    }()
  }]);
}();
module.exports = Splash;